import Footer from "../components/Footer"
import Navigation from "../components/Navigation"


function ErrorPage() {

    return (
        <>
        <Navigation />
        <h1>ERRO</h1>
        <Footer />
        </>
    )
}

export default ErrorPage